import React from "react";
import classes from "./backdrop.module.css";
function Backdrop(props) {
  return <div className={classes.backdrop} onClick={props.click} />;
}

export default Backdrop;
